__turbopack_context__.v({
  "container": "apA_Yq_container",
  "paddingBottom0": "apA_Yq_paddingBottom0",
  "paddingBottom112": "apA_Yq_paddingBottom112",
  "paddingBottom128": "apA_Yq_paddingBottom128",
  "paddingBottom16": "apA_Yq_paddingBottom16",
  "paddingBottom32": "apA_Yq_paddingBottom32",
  "paddingBottom48": "apA_Yq_paddingBottom48",
  "paddingBottom64": "apA_Yq_paddingBottom64",
  "paddingBottom80": "apA_Yq_paddingBottom80",
  "paddingBottom96": "apA_Yq_paddingBottom96",
  "paddingTop0": "apA_Yq_paddingTop0",
  "paddingTop112": "apA_Yq_paddingTop112",
  "paddingTop128": "apA_Yq_paddingTop128",
  "paddingTop16": "apA_Yq_paddingTop16",
  "paddingTop32": "apA_Yq_paddingTop32",
  "paddingTop48": "apA_Yq_paddingTop48",
  "paddingTop64": "apA_Yq_paddingTop64",
  "paddingTop80": "apA_Yq_paddingTop80",
  "paddingTop96": "apA_Yq_paddingTop96",
  "title": "apA_Yq_title",
  "titleContainer": "apA_Yq_titleContainer",
});
